<template>
  <div class="tree-box">
    <type-regist-box-header :is-regist="isRegist" :disabled="disabled"></type-regist-box-header>
    <vue-perfect-scrollbar :class="classes" tagname="div" :key="classes">
      <tree-root :tree-list="treeList">
      </tree-root>
    </vue-perfect-scrollbar>
    <v-btn block @click="$emit('isMoreViewChange')" class="tree-box-more-btn-box" :disabled="disabled">
      <i :class="isMoreView ? 'UXicon-arrow_top' : 'UXicon-arrow_bottom'"></i>
    </v-btn>
    <type-regist-box-header :is-regist="isRegist" :disabled="disabled"></type-regist-box-header>
  </div>
</template>

<script>
import TypeRegistBoxHeader from './typeRegistBoxHeader'
import TreeRoot from './treeRoot'
export default {
  name: 'treeBox',
  components: {TypeRegistBoxHeader, TreeRoot},
  props: {
    treeList: {
      type: Array,
      required: true
    },
    isMoreView: {
      type: Boolean,
      required: true
    },
    isRegist: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.$eventBus.$on('tree-scroll-btm', this.scrollToEnd)
  },
  computed: {
    classes () {
      return this.isMoreView ? 'tree-struc-box more' : 'tree-struc-box'
    }
  },
  methods: {
    scrollToEnd () {
      setTimeout(() => {
        try {
          const container = this.$el.querySelector('.ps-container')
          if (container) {
            container.scrollTop = container.scrollHeight
          }
        } catch (e) {

        }
      }, 0)
    }
  }
}
</script>

<style lang="scss">
.tree-box {
  min-width: 340px;
  margin-right: 10px;
  width: 100%;
  .tree-struc-box {
    min-height: 406px;
    background-color: #F5F5F5;
    padding: {
      top: 10px;
      bottom: 10px;
      left: 15px;
      right: 15px;
    }

    max-height: 406px;
    overflow-y: hidden;

    &.more {
       min-height: 812px;
       max-height: 812px;
     }

    .ps__scrollbar-y {
      width: 5px;
      right: 10px;
    }
  }

  .tree-box-more-btn-box {
    border-radius: 0px;
    margin: 0px;
    display: flex;
    justify-content: center;
    height: 25px;
    cursor: pointer;
    background-color: #DCDCDC !important;
    will-change: auto !important;
    box-shadow: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/agent/components/treeBox.vue